// extracted by mini-css-extract-plugin
export default {"breadcrumb":"CardEditPage_breadcrumb__rQM6F","card-edit-segment":"CardEditPage_card-edit-segment__chL+k"};